export const rootNode = document.getElementById('marketing-finance-sectors-root');

export const initParams = {
  data: JSON.parse(rootNode.dataset.data),
};

console.log('initParams', initParams);
